import { FormattedMessage } from 'react-intl';

import type { ArticleType } from '@xing-com/crate-articles-article-editor';
import { useLoginState } from '@xing-com/crate-hooks-use-login-state';
import { SocialBar } from '@xing-com/crate-social-bar';
import { CommentList } from '@xing-com/crate-social-comment-list';

import { Styled } from './styles';

export const CHANNEL_INSIDER_ARTICLE = 'wbm/News_Insider_Article';

type ArticleCommentsProps = {
  urn: string;
};

const ArticleComments: React.FC<ArticleCommentsProps> = ({ urn }) => (
  <Styled.CommentsContainer>
    <Styled.CommentsHeadline size="xxlarge">
      <FormattedMessage id="ARTICLES_ARTICLE_VIEWER_COMMENTS_HEADLINE" />
    </Styled.CommentsHeadline>

    <div id="commentListContainer">
      <CommentList propChannel={CHANNEL_INSIDER_ARTICLE} urn={urn} />
    </div>
  </Styled.CommentsContainer>
);

type ArticleSocialInteractionsProps = {
  article: ArticleType;
  page?: string;
};

const ArticleSocialInteractions: React.FC<ArticleSocialInteractionsProps> = ({
  article,
  page,
}) => {
  const { isLoggedIn } = useLoginState();

  if (!article) {
    return null;
  }

  const triggerCommentFocus = (): void => {
    const commentListContainer = document?.querySelector<HTMLDivElement>(
      '#commentListContainer textarea'
    );

    if (commentListContainer) {
      commentListContainer.focus();
      commentListContainer.scrollIntoView();
    }
  };

  return (
    <Styled.ArticleSocialInteractionsContainer data-testid="article-viewer-social-interactions">
      <SocialBar
        propChannel={CHANNEL_INSIDER_ARTICLE}
        commentClick={triggerCommentFocus}
        url={article.visitUrl}
        urn={article.socialInteractionTargetUrn || ''}
        backendTrackingMetaData={{ page }}
      />
      {isLoggedIn ? (
        <ArticleComments urn={article.socialInteractionTargetUrn || ''} />
      ) : null}
    </Styled.ArticleSocialInteractionsContainer>
  );
};

export default ArticleSocialInteractions;
